import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconSelect = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <rect width="24" height="24" fill="none" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 7C19 7.55228 18.5523 8 18 8C17.4477 8 17 7.55228 17 7V6C17 5.44772 17.4477 5 18 5C18.5523 5 19 5.44772 19 6V7ZM19 11C19 11.5523 18.5523 12 18 12C17.4477 12 17 11.5523 17 11V10C17 9.44772 17.4477 9 18 9C18.5523 9 19 9.44772 19 10V11ZM19 15C19 15.5523 18.5523 16 18 16C17.4477 16 17 15.5523 17 15V14C17 13.4477 17.4477 13 18 13C18.5523 13 19 13.4477 19 14V15ZM17 19C16.4477 19 16 18.5523 16 18C16 17.4477 16.4477 17 17 17H18C18.5523 17 19 17.4477 19 18C19 18.5523 18.5523 19 18 19H17ZM13 19C12.4477 19 12 18.5523 12 18C12 17.4477 12.4477 17 13 17H14C14.5523 17 15 17.4477 15 18C15 18.5523 14.5523 19 14 19H13ZM9 19C8.44772 19 8 18.5523 8 18C8 17.4477 8.44772 17 9 17H10C10.5523 17 11 17.4477 11 18C11 18.5523 10.5523 19 10 19H9ZM5 17C5 16.4477 5.44772 16 6 16C6.55228 16 7 16.4477 7 17V18C7 18.5523 6.55228 19 6 19C5.44772 19 5 18.5523 5 18V17ZM5 13C5 12.4477 5.44772 12 6 12C6.55228 12 7 12.4477 7 13V14C7 14.5523 6.55228 15 6 15C5.44772 15 5 14.5523 5 14V13ZM5 9C5 8.44772 5.44772 8 6 8C6.55228 8 7 8.44772 7 9V10C7 10.5523 6.55228 11 6 11C5.44772 11 5 10.5523 5 10V9ZM7 5C7.55228 5 8 5.44772 8 6C8 6.55228 7.55228 7 7 7H6C5.44772 7 5 6.55228 5 6C5 5.44772 5.44772 5 6 5H7ZM11 5C11.5523 5 12 5.44772 12 6C12 6.55228 11.5523 7 11 7H10C9.44772 7 9 6.55228 9 6C9 5.44772 9.44772 5 10 5H11ZM15 5C15.5523 5 16 5.44772 16 6C16 6.55228 15.5523 7 15 7H14C13.4477 7 13 6.55228 13 6C13 5.44772 13.4477 5 14 5H15Z"
          fill="currentColor"
        />
      </svg>
    );
  }
);
